/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CallingIdentity } from './CallingIdentity';
import {
    CallingIdentityFromJSON,
    CallingIdentityFromJSONTyped,
    CallingIdentityToJSON,
} from './CallingIdentity';

/**
 * Extends structures with details about who created/updated the resource
 * @export
 * @interface UpdateSettingResponseContent
 */
export interface UpdateSettingResponseContent {
    /**
     * 
     * @type {CallingIdentity}
     * @memberof UpdateSettingResponseContent
     */
    createdBy: CallingIdentity;
    /**
     * 
     * @type {CallingIdentity}
     * @memberof UpdateSettingResponseContent
     */
    updatedBy: CallingIdentity;
    /**
     * The time at which the resource was created
     * @type {number}
     * @memberof UpdateSettingResponseContent
     */
    createdAt: number;
    /**
     * The time of the most recent update
     * @type {number}
     * @memberof UpdateSettingResponseContent
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateSettingResponseContent
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSettingResponseContent
     */
    userKey: string;
    /**
     * 
     * @type {any}
     * @memberof UpdateSettingResponseContent
     */
    userValue: any | null;
}


/**
 * Check if a given object implements the UpdateSettingResponseContent interface.
 */
export function instanceOfUpdateSettingResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "createdBy" in value;
    isInstance = isInstance && "updatedBy" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "userKey" in value;
    isInstance = isInstance && "userValue" in value;

    return isInstance;
}

export function UpdateSettingResponseContentFromJSON(json: any): UpdateSettingResponseContent {
    return UpdateSettingResponseContentFromJSONTyped(json, false);
}

export function UpdateSettingResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSettingResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdBy': CallingIdentityFromJSON(json['createdBy']),
        'updatedBy': CallingIdentityFromJSON(json['updatedBy']),
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'userId': json['userId'],
        'userKey': json['userKey'],
        'userValue': json['userValue'],
    };
}

export function UpdateSettingResponseContentToJSON(value?: UpdateSettingResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdBy': CallingIdentityToJSON(value.createdBy),
        'updatedBy': CallingIdentityToJSON(value.updatedBy),
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'userId': value.userId,
        'userKey': value.userKey,
        'userValue': value.userValue,
    };
}

